<template>
	<div class="contentPage">
		<router-view/>
	</div>
</template>

<script>
export default {
	name: "Trips"
};
</script>

